import { render, staticRenderFns } from "./ChannelsSelectionDialog.vue?vue&type=template&id=6defc5d8"
import script from "./ChannelsSelectionDialog.vue?vue&type=script&lang=js"
export * from "./ChannelsSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports